import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/firebase.js'

// Function to wait for Firebase Auth to initialize
const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/tours'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
    },
    {
      path: '/create',
      name: 'create',
      component: () => import('../views/EditView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/edit/:firebaseKey/:tourId',
      name: 'edit',
      component: () => import('../views/EditView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/tours',
      name: 'tours',
      component: () => import('@/views/VirtualTours.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/view/:firebaseKey/:tourId',
      name: 'view',
      component: () => import('../views/ViewTour.vue'),
    },
  ],
})

// Navigation guard to check authentication
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const currentUser = await getCurrentUser()

  if (requiresAuth && !currentUser) {
    // Redirect to login with the intended destination
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (to.path === '/login' && currentUser) {
    // If already logged in and trying to access login, redirect to tours
    next('/tours')
  } else {
    next()
  }
})

export default router
